import { MantineThemeOverride } from '@mantine/core'
import { lightTheme } from 'styles/themes/lightTheme'

export const darkTheme: MantineThemeOverride = {
    ...lightTheme,
    colorScheme: 'dark',
    // colors: mantineColors,
}
